import { Injectable } from '@angular/core';

import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';

import { Observable } from 'rxjs';

import { GurdServiceService } from './Service/gurd-service.service';


@Injectable({
  providedIn: 'root'
})
export class GurdGuard implements CanActivate {

  acssess: any;

  constructor(private Authguardservice: GurdServiceService, private router: Router) {

  }

  canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {

    var data = window.localStorage.getItem("menu") as any;

    const ForceChangePass = window.localStorage.getItem('ForceChangePass');

    if (data != null) this.acssess = JSON.parse(this.Authguardservice.decrypt(data));

    if (!this.Authguardservice.gettoken()) {

      this.router.navigate(['/login'], { queryParams: { auth: false } });

    }

    if (ForceChangePass && this.Authguardservice.decrypt(ForceChangePass) === 'true' && state.url !== '/update-password') {

      this.router.navigate(['/update-password']);

      return false;

    }

    if (state.url == "/busLine" && this.acssess.bBusEdit == false) {

      this.router.navigateByUrl("/");

    }

    if (state.url == "/manageEvent" && this.acssess.bLiveJournal == false) {

      this.router.navigateByUrl("/");

    }

    if (state.url == "/device" && this.acssess.bEnableAddID == false) {

      this.router.navigateByUrl("/");

    }

    if (state.url == "/dashbord" && this.acssess.bEnableDashboard == false) {

      this.router.navigateByUrl("/");

    }

    if (state.url == "/changePass" && this.acssess.bChangePass == false) {

      this.router.navigateByUrl("/");

    }

    if (state.url == "/saveUser" && this.acssess.bUserManagment == false) {

      this.router.navigateByUrl("/");

    }

    if (state.url == "/user" && this.acssess.bEnableIntroducedMobile == false) {

      this.router.navigateByUrl("/");

    }

    if (state.url == "/manageInput" && this.acssess.bIOManage == false) {

      this.router.navigateByUrl("/");

    }

    if (state.url == "/supportManager" && this.acssess.bSupport == false) {
      this.router.navigateByUrl("/");
    }

    if (state.url.includes("/carArea") && this.acssess.bDefGeoFance == false) {
      this.router.navigateByUrl("/");
    }

    if (state.url.includes("/services") && this.acssess.bService == false) {
      this.router.navigateByUrl("/");
    }

    if (state.url.includes("/income") && this.acssess.bEnableCarRvenues == false) {
      this.router.navigateByUrl("/");
    }

    if (state.url.includes("/repairs") && this.acssess.bRepairs == false) {
      this.router.navigateByUrl("/");
    }

    if (state.url.includes("/refule") && this.acssess.bRefueling == false) {
      this.router.navigateByUrl("/");
    }

    if (state.url.includes("/support") && this.acssess.bEnableTiket == false) {
      this.router.navigateByUrl("/");
    }

    return this.Authguardservice.gettoken();

  }

}
